import { ACCIONES } from './constantes';

export const formatearErroresParaNotificaciones = (errores) => {
  if (typeof errores == 'string') {
    return errores;
  }

  let erroresFormateados = '';

  Object.keys(errores).forEach((key) => {
    const itemsErrores = errores[key].map((item) => `<li>${item}</li>`).join('');

    erroresFormateados += itemsErrores;
  });

  return erroresFormateados;
};

export const api = (
  accion,
  fnServicio,
  datosPeticion,
  opciones,
  callbackPre = null,
  callbackPost = null,
  callbackOk = null,
  callbackError = null,
) => {
  return async () => {
    if (!Object.values(ACCIONES).includes(accion)) {
      window.console.error('Acción no permitida');

      return;
    }

    if (callbackPre) {
      callbackPre();
    }

    try {
      let response = null;

      if (accion == ACCIONES.LISTAR_TODOS) {
        response = await fnServicio(opciones);
      } else if (accion == ACCIONES.LISTAR_POR_ID) {
        response = await fnServicio(datosPeticion.id, opciones);
      } else if (accion == ACCIONES.EDITAR) {
        response = await fnServicio(datosPeticion.id, datosPeticion, opciones);
      } else if (accion == ACCIONES.REGISTRAR) {
        response = await fnServicio(datosPeticion, opciones);
      } else if (accion == ACCIONES.ELIMINAR) {
        response = await fnServicio(datosPeticion.id, opciones);
      }

      const data = response?.data;
      const datos = data?.datos;
      const mensaje = data?.mensaje;

      if (callbackOk) {
        callbackOk(datos, mensaje);
      }
    } catch (error) {
      const data = error?.response?.data;
      const errores = data?.errores;
      const erroresFormateados = errores ? formatearErroresParaNotificaciones(errores) : data?.mensaje;
      const mensaje = erroresFormateados || error?.message || 'Error al consultar';

      if (callbackError) {
        callbackError(errores, mensaje);
      }
    } finally {
      if (callbackPost) {
        callbackPost();
      }
    }
  };
};

export const cellRendererNumeroRegistro = (param) => {
  if (param.node.rowPinned) {
    return undefined;
  }

  return param.node.rowIndex + 1;
};

export const cellRendererSiONo = (llave, textoSi, textoNo) => {
  return (params) => {
    const estado = params.data[llave];
    const color = estado ? 'green' : 'red';

    return /*html*/ `
      <span class="v-chip v-chip--outlined v-chip--pill theme--dark v-size--x-small ${color} ${color}--text body-2">
          <span class="v-chip__content"> ${estado ? textoSi : textoNo}</span>
      </span>
    `;
  };
};

export const generarUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
};

export const anioMesAnterior = (cantidadMeses) => {
  const fecha = new Date();

  fecha.setMonth(fecha.getMonth() - cantidadMeses);

  const mes = fecha.getMonth() + 1;
  const anio = fecha.getFullYear();

  return `${anio}-${mes < 10 ? `0${mes}` : mes}`;
};

export const anioMesActual = () => {
  const fecha = new Date();

  const mes = fecha.getMonth() + 1;
  const anio = fecha.getFullYear();

  return `${anio}-${mes < 10 ? `0${mes}` : mes}`;
};

export const formatearNumeroAMoneda = (numero) => {
  if (typeof numero == 'number') {
    numero = numero.toFixed(2);
  }

  if (typeof numero == 'string') {
    numero = parseFloat(numero).toFixed(2);
  }

  return numero
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    .replace(/.([^.]*)$/, ',$1');
};

export const fechasDesdeHasta = (rangoFechas) => {
  let desde = null;
  let hasta = null;

  if (rangoFechas) {
    if (rangoFechas.length != 2) {
      rangoFechas = [];
    }

    if (rangoFechas.length == 2) {
      const fecha1 = new Date(rangoFechas[0]);
      const fecha2 = new Date(rangoFechas[1]);

      if (fecha1 > fecha2) {
        desde = rangoFechas[1];
        hasta = rangoFechas[0];
      } else {
        desde = rangoFechas[0];
        hasta = rangoFechas[1];
      }
    }
  }

  return { desde, hasta };
};

export const obtenerColores = (cantidad, alpha = 1) => {
  if (alpha < 0 || alpha > 1) {
    alpha = 1;
  }

  alpha = parseFloat(alpha.toFixed(2));

  const alphaBorde = alpha + 0.4 > 1 ? 1 : parseFloat((alpha + 0.4).toFixed(2));

  const colores = [
    `rgba(255, 99, 132, alpha)`,
    `rgba(54, 162, 235, alpha)`,
    `rgba(255, 206, 86, alpha)`,
    `rgba(75, 192, 192, alpha)`,
    `rgba(153, 102, 255, alpha)`,
    `rgba(255, 159, 64, alpha)`,
    `rgba(199, 199, 199, alpha)`,
    `rgba(83, 102, 255, alpha)`,
    `rgba(255, 99, 255, alpha)`,
    `rgba(99, 255, 132, alpha)`,
    `rgba(255, 177, 193, alpha)`,
    `rgba(144, 238, 144, alpha)`,
    `rgba(255, 218, 128, alpha)`,
    `rgba(176, 224, 230, alpha)`,
    `rgba(221, 160, 221, alpha)`,
    `rgba(255, 127, 80, alpha)`,
    `rgba(106, 90, 205, alpha)`,
    `rgba(60, 179, 113, alpha)`,
    `rgba(255, 105, 180, alpha)`,
    `rgba(70, 130, 180, alpha)`,
  ];

  if (cantidad <= colores.length) {
    return colores.slice(0, cantidad).map((color) => {
      return {
        fondo: color.replace('alpha', alpha.toString()),
        borde: color.replace('alpha', alphaBorde.toString()),
      };
    });
  } else {
    const coloresExtendidos = [];
    for (let i = 0; i < cantidad; i++) {
      const color = colores[i % colores.length];

      coloresExtendidos.push({
        fondo: color.replace('alpha', alpha.toString()),
        borde: color.replace('alpha', alphaBorde.toString()),
      });
    }

    return coloresExtendidos;
  }
};

export const obtenerUrlAPIComisiones = (uri) => {
  return `${process.env.VUE_APP_URL_API_COMISIONES}${uri}`;
};
